/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Additional data for a subscription step (optional, depends on step type)
 * @export
 * @interface SubscriptionStepDataDto
 */
export interface SubscriptionStepDataDto {
    /**
     * Unique identifier of the quote (for QUOTE sub-steps)
     * @type {string}
     * @memberof SubscriptionStepDataDto
     */
    quoteId?: string;
    /**
     * Human-readable quote identifier (e.g., CHO-0WA29-CON-VNR15)
     * @type {string}
     * @memberof SubscriptionStepDataDto
     */
    quoteIdentifier?: string;
    /**
     * Unique identifier of the borrower (for borrower contractualization sub-steps)
     * @type {string}
     * @memberof SubscriptionStepDataDto
     */
    borrowerId?: string;
}

/**
 * Check if a given object implements the SubscriptionStepDataDto interface.
 */
export function instanceOfSubscriptionStepDataDto(value: object): value is SubscriptionStepDataDto {
    return true;
}

export function SubscriptionStepDataDtoFromJSON(json: any): SubscriptionStepDataDto {
    return SubscriptionStepDataDtoFromJSONTyped(json, false);
}

export function SubscriptionStepDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionStepDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteId': json['quoteId'] == null ? undefined : json['quoteId'],
        'quoteIdentifier': json['quoteIdentifier'] == null ? undefined : json['quoteIdentifier'],
        'borrowerId': json['borrowerId'] == null ? undefined : json['borrowerId'],
    };
}

export function SubscriptionStepDataDtoToJSON(json: any): SubscriptionStepDataDto {
    return SubscriptionStepDataDtoToJSONTyped(json, false);
}

export function SubscriptionStepDataDtoToJSONTyped(value?: SubscriptionStepDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quoteId': value['quoteId'],
        'quoteIdentifier': value['quoteIdentifier'],
        'borrowerId': value['borrowerId'],
    };
}

